import * as React from 'react';
import {Link} from 'react-router-dom';
import AppConfig from '../../config/AppConfig';
import {buildUrl} from '../../helpers/utility';

export default ({collapsed}) => {
    return (
        <div className='isoLogoWrapper'>
            {collapsed
                ? (
                    <div>
                        <h3>
                            <Link to={buildUrl('/dashboard')}>
                                <i className={AppConfig.siteConfig.siteIcon}/>
                            </Link>
                        </h3>
                    </div>
                )
                : (
                    <h3>
                        <Link to={buildUrl('/dashboard')}>{AppConfig.siteConfig.siteName}</Link>
                    </h3>
                )}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/utility/logo.tsx